import React, { useState } from 'react';
import { EnvelopeSimple, MapPin, Phone } from '@phosphor-icons/react';
import { SectionHeading } from './BrandMark';
import { CONTACT } from './content';

const INTEREST_KEYS = ['erp', 'lifetide', 'website', 'other'];

export function ContactSection({ copy, defaultInterest = 'erp' }) {
  const section = copy.contact;
  const [interest, setInterest] = useState(defaultInterest);

  const mailto = `mailto:${CONTACT.email}?subject=${encodeURIComponent(`${section.subjectPrefix} ${section.interests[interest]}`)}`;

  const rows = [
    { icon: Phone, label: section.phoneLabel, value: CONTACT.phone, href: CONTACT.phoneHref },
    { icon: EnvelopeSimple, label: section.emailLabel, value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: section.locationLabel, value: CONTACT.location },
  ];

  return (
    <section id="contact" className="scroll-mt-16 bg-[#F8F6F0] py-24 lg:py-32" aria-labelledby="contact-title" data-testid="contact-section">
      <div className="mx-auto grid max-w-7xl items-start gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <div>
          <SectionHeading eyebrow={section.eyebrow} title={section.title} subtitle={section.subtitle} />
          <h2 id="contact-title" className="sr-only">{section.title}</h2>
          <ul className="mt-10 space-y-6" data-reveal>
            {rows.map(({ icon: Icon, label, value, href }) => (
              <li key={label} className="flex items-center gap-5">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-[#D4AF37]/60 text-[#8A6A12]">
                  <Icon size={22} aria-hidden="true" />
                </span>
                <span>
                  <span className="block font-landing text-[0.68rem] font-semibold uppercase tracking-[0.24em] text-[#8A6A12]">{label}</span>
                  {href ? (
                    <a href={href} className="font-display text-xl text-[#0A0A0A] underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]">{value}</a>
                  ) : (
                    <span className="font-display text-xl text-[#0A0A0A]">{value}</span>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div className="border-t-2 border-[#D4AF37] bg-white p-8 shadow-[0_30px_80px_-40px_rgba(10,10,10,0.45)] sm:p-10" data-reveal style={{ '--reveal-delay': '120ms' }}>
          <p className="font-landing text-xs font-semibold uppercase tracking-[0.24em] text-[#0A0A0A]" id="interest-label">{section.interestLabel}</p>
          <div className="mt-5 flex flex-wrap gap-3" role="radiogroup" aria-labelledby="interest-label">
            {INTEREST_KEYS.map((key) => {
              const active = interest === key;
              return (
                <button
                  key={key}
                  type="button"
                  role="radio"
                  aria-checked={active}
                  onClick={() => setInterest(key)}
                  className={`h-11 border px-5 font-landing text-[0.8rem] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] ${
                    active ? 'border-[#0A0A0A] bg-[#0A0A0A] text-[#F8F6F0]' : 'border-[#0A0A0A]/25 text-[#0A0A0A] hover:border-[#0A0A0A]'
                  }`}
                >
                  {section.interests[key]}
                </button>
              );
            })}
          </div>
          <a
            href={mailto}
            className="mt-8 inline-flex h-14 w-full items-center justify-center gap-3 bg-gradient-to-b from-[#E2C15A] to-[#C39B22] px-8 font-landing text-[0.78rem] font-semibold uppercase tracking-[0.16em] text-[#0A0A0A] transition-transform hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0A0A0A] focus-visible:ring-offset-2"
          >
            <EnvelopeSimple size={20} weight="bold" aria-hidden="true" />
            {section.send}
          </a>
        </div>
      </div>
    </section>
  );
}
